        import { useLocation, Link } from 'react-router-dom'
import { Button } from '../../components/Button'
import { ROUTES } from '../../routes/constants'

export const ComponentsNavigation = () => {
  const location = useLocation()

  const navigationItems = [
    { label: 'Buttons', path: ROUTES.COMPONENTS_BUTTONS },
    { label: 'Inputs', path: ROUTES.COMPONENTS_INPUTS },
    { label: 'Selects', path: ROUTES.COMPONENTS_SELECTS },
    { label: 'Cards', path: ROUTES.COMPONENTS_CARDS },
    { label: 'Modals', path: ROUTES.COMPONENTS_MODALS },
    { label: 'Textarea e checkbox', path: ROUTES.COMPONENTS_TEXTAREA },
    { label: 'Badges', path: ROUTES.COMPONENTS_BADGES },
    { label: 'Tables', path: ROUTES.COMPONENTS_TABLES },
    { label: 'Floating Toolbar', path: ROUTES.COMPONENTS_FLOATING_TOOLBAR },
  ]

  return (
    <div className="mb-8 flex justify-center">
      <nav className="bg-white rounded-lg shadow-sm p-1 flex space-x-1">
        {navigationItems.map((item) => (
          <Link key={item.path} to={item.path}>
            <Button 
              variant="ghost" 
              size="sm" 
              className={
                location.pathname === item.path 
                  ? "text-blue-600 bg-blue-50" 
                  : "text-gray-500 hover:text-blue-600"
              }
            >
              {item.label}
            </Button>
          </Link>
        ))}
      </nav>
    </div>
  )
}